import React from 'react'
import styled from 'styled-components';
import RevenueBanner from "../../Images/RevenueBanner.png";


const Root = styled.div``;
const Container = styled.div``;
const ImageWrapper = styled.div`
display: flex;
justify-content:center;
text-align:center;
align-items:center;
padding-right:10px;
`;
const Image = styled.img`
border-radius:12px;
`;

const BannerRevenue = () => {
  return (
    <Root>
    <Container>
    <ImageWrapper>
                <Image src={RevenueBanner}>
                </Image>
            </ImageWrapper>
      
    </Container>
   </Root>
  )
}

export default BannerRevenue;